import React from 'react';

import s from './style.module.css';
import * as Icon from 'react-feather';

class Firework extends React.Component {
	render() {
		return (
			<div className={s.animation}>
				<span className={ `${s.dot} ${s.dot1}` }></span>
				<span className={ `${s.dot} ${s.dot2}` }></span>
				<span className={ `${s.dot} ${s.dot3}` }></span>
				<span className={ `${s.dot} ${s.dot4}` }></span>
				<span className={ `${s.dot} ${s.dot5}` }></span>
				<span className={ `${s.dot} ${s.dot6}` }></span>
				<span className={ `${s.dot} ${s.dot7}` }></span>
				<span className={ `${s.dot} ${s.dot8}` }></span>
				<span className={ `${s.dot} ${s.dot9}` }></span>
				<span className={ `${s.dot} ${s.dot10}` }></span>
				<span className={ `${s.dot} ${s.dot11}` }></span>
				<span className={ `${s.dot} ${s.dot12}` }></span>
				<span className={ `${s.dot} ${s.dot13}` }></span>
				<div className={ `${s.iconWrapper}` }>
					<Icon.Check className={s.icon} size="20" color="#fff" />
				</div>
			</div>
		)
	}
}

export default Firework;